module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Molotov_C.7cdac964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_Molotov_C.png
// module id = ./src/assets/item/Weapon/Throwable/Item_Weapon_Molotov_C.png
// module chunks = 0